import * as angular from 'angular';

export class ReferenceFieldPickerController implements ng.IController {
  /* tslint:disable */
  $onInit = () => {};
  /* tslint:enable */
  refHolderValue;

  private selectedFieldGroup;
  private availableFields;
  private selectedInstance;
  private hasNoValuesAttributes;

  /* @ngInject */
  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private elementHelper,
    private mappings
  ) {
    let condition = this.$scope.refHolder;
    if (condition && condition[this.$scope.referenceFieldKey]) {
      this.setAvailableFields(condition);
      this.selectedInstance = condition[this.$scope.referenceFieldKey].groupIndex;
      this.hasNoValuesAttributes = this.mappings.referenceOptions.disallowedRefValueSelectionTypes.indexOf(condition['@type']) !== -1;
      if (this.hasNoValuesAttributes) {
        condition.values = undefined;
        condition.valuesExpression = undefined;
      } else if (!condition.values) {
        condition.values = [];
      }
    }
  }

  setAvailableFields(condition) {
    let fields = [];
    if (condition && condition[this.$scope.referenceFieldKey] && condition[this.$scope.referenceFieldKey].groupId) {
      this.selectedFieldGroup = this.$scope.models.availableFieldGroups.find(
        (f) => f.id === condition[this.$scope.referenceFieldKey].groupId
      );
      angular.forEach(this.selectedFieldGroup.rows, (row) => (fields = fields.concat(row.fields)));
    }
    angular.forEach(fields, (field, index) => {
      if (field === this.$scope.models.element) {
        fields[index] = this.$scope.models.elementCopy;
      }
    });

    fields = fields.filter((field) => {
      let allowedRefTypes: string[] = this.$scope.conditions[condition['@type']].allowedReferenceFields;
      return allowedRefTypes.some((allowedRefType) => allowedRefType === field.type.toLowerCase());
    });
    this.availableFields = fields;
  }

  setInstance() {
    this.$scope.refHolder[this.$scope.referenceFieldKey].groupIndex = this.selectedInstance
      ? parseInt(this.selectedInstance, 10)
      : 0;
  }

  getSelectedField() {
    return this.availableFields.find((a) => a.id === this.$scope.refHolder[this.$scope.referenceFieldKey].fieldId);
  }

  addConditionValue(refHolder) {
    this.elementHelper.addConditionValue(refHolder, this.refHolderValue);
    this.refHolderValue = '';
  }

  referenceFieldChanged(refHolder) {
    if (this.hasNoValuesAttributes) {
      refHolder.values = undefined;
      refHolder.valuesExpression = undefined;
    } else {
      refHolder.values = [];
      refHolder.valuesExpression = undefined;
    }
  }
}
